import type { AgentExecutionLight } from "@stockline/shared/types/ai/execution"

/**
 * agent_type values used for sub-agent executions: forked branches and
 * dispatched sub-workflows. These belong to a parent run and are hidden from
 * the user-facing /ai executions list — the full multi-agent view (parents +
 * children) lives at /ai-admin, which reads a separate (legacy) endpoint.
 *
 * Mirrors the Python producers: run_fork (agent_type="fork") and
 * run_sub_workflow (agent_type="sub_workflow") in ai/agent_system/core/.
 * agent_type is the stable structural marker — preferred over the display name.
 */
export const SUBAGENT_AGENT_TYPES: readonly string[] = ["fork", "sub_workflow"]

export function isSubagentExecution(
  execution: Pick<AgentExecutionLight, "agentType">
): boolean {
  return SUBAGENT_AGENT_TYPES.includes(execution.agentType)
}
